"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * TODO: Let's make sure this API Key is from Prod. I'm OK wit hard-coding it into the project so long as it's not from Dev
 */
var GoogleHeatMap = function GoogleHeatMap(_ref) {
  var data = _ref.data,
      lat = _ref.lat,
      lng = _ref.lng,
      zoom = _ref.zoom;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      heatMap = _useState2[0],
      setHeatMap = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!window.initHeatMap) {
      window.initHeatMap = initMap;
      var script = document.createElement("script");
      script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCSvWkVdrGsFpOsrnvCLVFZWpGgtGbrVRw&libraries=visualization&callback=initHeatMap";
      script.async = true;
      document.body.appendChild(script);
    } else {
      initMap();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  (0, _react.useEffect)(function () {
    if (heatMap) {
      heatMap.map.setCenter(new google.maps.LatLng(lat, lng));
      heatMap.map.setZoom(zoom);
    }
  }, [lat, lng, zoom]); // eslint-disable-line react-hooks/exhaustive-deps

  (0, _react.useEffect)(function () {
    if (heatMap && data) {
      heatMap.setData(data.map(function (item) {
        return new google.maps.LatLng(item.lat, item.lng);
      }));
    }
  }, [heatMap, data]);

  var initMap = function initMap() {
    var config = {
      center: {
        lat: lat,
        lng: lng
      },
      zoom: zoom
    };
    var map = new google.maps.Map(document.getElementById('map'), config);
    var heatmap = new google.maps.visualization.HeatmapLayer({
      data: data.map(function (item) {
        return new google.maps.LatLng(item.lat, item.lng);
      }),
      map: map,
      radius: 20,
      gradient: ['rgba(0, 255, 255, 0)', // 'rgba(0, 255, 255, 1)',
      // 'rgba(0, 191, 255, 1)',
      'rgba(0, 127, 255, 1)', 'rgba(0, 63, 255, 1)', 'rgba(0, 0, 255, 1)', 'rgba(0, 0, 223, 1)', 'rgba(0, 0, 191, 1)', 'rgba(0, 0, 159, 1)', 'rgba(0, 0, 127, 1)', 'rgba(63, 0, 91, 1)', 'rgba(127, 0, 63, 1)', 'rgba(191, 0, 31, 1)', 'rgba(255, 0, 0, 1)']
    });
    setHeatMap(heatmap);
  }; // if (heatMap && data) {
  //     heatMap.setData(data.map(item => new google.maps.LatLng(item.lat, item.lng)));
  // }


  return /*#__PURE__*/_react.default.createElement("div", {
    id: "map",
    style: {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0,
      bottom: 0
    }
  });
};

GoogleHeatMap.defaultProps = {
  lat: 38.826557,
  lng: -96.111918,
  zoom: 4
};
var _default = GoogleHeatMap;
exports.default = _default;